export default __webpack_public_path__ + "static/media/1839.07d56dc8.png";